import React, { useState } from 'react';
import SliderV1 from '../slider/SliderV1';
import BoxNavigation from '../box_button/BoxButtonNavigation.js';
import HomeScrollGames from '../scroll/home_scroll_games.js';
import ProviderList from '../scroll/provider_scroll.js';
import PromotionSection from '../scroll/promotion_scroll.js';
import BestWinsSlider from '../slider/best_win_slider.js';
import ModalLogin from '../modal/modal_login.js';
import ModalRegister from '../modal/modal_register.js';
import Cookies from 'js-cookie';

import PromoHome from './promotion/PromoHome.js';

const Home = ({ isLogged, setIsLogged,lang,handleOpenRegisterModal,showLoginModal,openLoginModal,closeLoginModal, casinoSections, isUserCashBlocked, setIsUserCashBlocked, setHomeReload, setIsLoginModalOpen }) => {

  const filterSlug = () => {
    const allSlugs = ['casino', 'casino-live'/* , 'crash-game' */];
    

    if (!casinoSections) { return []; }
    // console.log(allSlugs.filter(slug => casinoSections[slug] == false));
    return allSlugs.filter(slug => casinoSections[slug] == false);
  };

  return (
    <div>
      {isUserCashBlocked && (
        <div className={`modal fade login_modal ${isUserCashBlocked ? 'show' : ''}`} style={{display: 'block'}} >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h3>Attention</h3>
              </div>
              <div className="modal-body">
                <img src={"/assets/img/cash-block.png"}></img>
                <div className="field button-field">
                  <button onClick={() => {setIsUserCashBlocked(false);     Cookies.remove('user_cash_block');}}>Ok</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      <SliderV1 lang={lang} sliderType="Home" isLogged={isLogged} handleOpenRegisterModal={handleOpenRegisterModal} />
      {/* <BoxNavigation casinoSections={casinoSections}/> */}
      <HomeScrollGames isLogged={isLogged} onOpenLogin={openLoginModal} casinoSections={casinoSections}/>
      <ProviderList game_slugs={filterSlug()} limit="100" casinoSections={casinoSections} isLogged={isLogged} setIsLoginModalOpen={setIsLoginModalOpen}/>
     
      <BestWinsSlider />

      {/* <PromoHome isLogged={isLogged} setIsLogged={setIsLogged} lang={lang} /> */}
      <ModalLogin show={showLoginModal} onClose={closeLoginModal} setIsLogged={setIsLogged} onOpenRegisterModal={handleOpenRegisterModal} setIsUserCashBlocked={setIsUserCashBlocked} setHomeReload={setHomeReload}/>
     
    </div>
  );
};

export default Home;
